// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__S11uZ","mainVideo":"Hero_mainVideo__p_6R1"};